<template>
    <div>
      <template v-for="(runner, k) in markets">
        <v-card
          :key="`key-${k}`"
          class="d-flex align-center item-odds"
          dense
          light
          flat
          tile
          height="45"
        >
          <v-btn
            v-if="!twoOdds"
            text
            tile
            color="white"
            class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
            v-bind="$attrs"
            v-on="$listeners"
          >
            <span class="black--text manage-overflow-two">
              {{ runner.name }}
              <!-- {{ books[markets.marketId] }} -->
              <span v-if="$auth.loggedIn">
                <br />
                <!-- OLD BOOK -->
                <span
                  v-if="
                    books &&
                    books[markets[0].marketId] &&
                    books[markets[0].marketId].length
                  "
                  :class="{
                    'green--text ':
                      getBooks(books, runner.id, '1') / getMyRate() > 0,
                    'red--text':
                      getBooks(books, runner.id, '1') / getMyRate() < 0,
                    'black--text ':
                      getBooks(books, runner.id, '1') / getMyRate() == 0
                  }"
                >
                  {{
                    (getBooks(books, runner.id, '1') / getMyRate())
                      | currencyFormat(2)
                  }}
                </span>
                <!-- OLD BOOK -->
                <!-- NEW BOOK -->
                <span
                  v-if="
                    newbookmakerMarketData &&
                    newbookmakerMarketData[markets[0].marketId] &&
                    newbookmakerMarketData[markets[0].marketId].length &&
                    newbookmakerMarketData[markets[0].marketId][0].book &&
                    newbookmakerMarketData[markets[0].marketId][0].book.length
                  "
                  :class="{
                    'green--text ':
                      getBooks(books, runner.id, '1') / getMyRate() +
                        getBooks(newbookmakerMarketData, runner.id, '1') >
                      0,
                    'red--text':
                      getBooks(books, runner.id, '1') / getMyRate() +
                        getBooks(newbookmakerMarketData, runner.id, '1') <
                      0,
                    'black--text ':
                      getBooks(books, runner.id, '1') / getMyRate() +
                        getBooks(newbookmakerMarketData, runner.id, '1') ==
                      0
                  }"
                >
                  <v-icon
                    v-if="
                      getBooks(books, runner.id, '1') &&
                      getBooks(newbookmakerMarketData, runner.id, '1')
                    "
                    size="12"
                    >mdi-chevron-right
                  </v-icon>
                  {{
                    (getBooks(books, runner.id, '1') / getMyRate() +
                      getBooks(newbookmakerMarketData, runner.id, '1'))
                      | currencyFormat(2)
                  }}
                </span>
                <!-- NEW BOOK -->
              </span>
            </span>
          </v-btn>
          <odds-disabled
            v-if="checkIfSuspendedOuter(socketStatus)"
            :text="checkIfSuspendedOuter(socketStatus)"
            v-bind="$attrs"
            v-on="$listeners"
          ></odds-disabled>
          <template v-for="(i, key) in xsOnlyOdds(true, 'back')">
            <btn-odds
              :key="'back' + key"
              type="back"
              :class="{ 'opacity-0': i !== 0 }"
              @betData="
                $store.commit('placeBet/openPopover', {
                  market: newPlacebet,
                  runner,
                  allRunners: markets,
                  oddsIndex: i,
                  odds: getObjValue(runner.batb, 0, 2 - i, 1.01),
                  type: 'back',
                  bettingType: 'artemisBookmaker'
                })
              "
            >
              <span
                v-if="markets && check(runner, 'batb', i, markets)"
                class="d-block text-center position-relative"
              >
                {{ getObjValue(runner.batb, 0, 2 - i, '-') | currencyFormat(2) }}
              </span>
  
              <span v-else>
                <span
                  v-if="check(runner, 'batb', i)"
                  class="d-block text-center position-relative"
                >
                  {{ getObjValue(runner.batb, i, 1, '-') }}
                </span>
                <span v-else class="d-block text-center">-</span>
              </span>
            </btn-odds>
          </template>
  
          <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly)">
            <btn-odds
              :key="'lay' + key"
              :class="{ 'opacity-0': i !== 0 }"
              type="lay"
              @betData="
                $store.commit('placeBet/openPopover', {
                  market: newPlacebet,
                  runner,
                  allRunners: markets,
                  oddsIndex: i,
                  odds: runner.batl[0][i],
                  type: 'lay',
                  bettingType: 'artemisBookmaker'
                })
              "
            >
              <span
                v-if="markets && check(runner, 'batl', i, markets)"
                class="d-block text-center position-relative"
              >
                {{ runner.batl[0][i] | currencyFormat(2) }}
              </span>
              <span v-else>
                <span
                  v-if="check(runner, 'batl', i) && markets.isOnlyback !== 'Yes'"
                  class="d-block text-center position-relative"
                >
                  <v-img
                    v-show="
                      runner.batl && runner.batl[i].marketValueBatl == 'down'
                    "
                    :src="require('@/assets/images/down.png')"
                    :lazy-src="require('@/assets/images/down.png')"
                    max-width="10px"
                    class="markets-down-arrow"
                  ></v-img>
                  <v-img
                    v-show="runner.batl && runner.batl[i].marketValueBatl == 'up'"
                    :src="require('@/assets/images/up.png')"
                    :lazy-src="require('@/assets/images/up.png')"
                    max-width="10px"
                    class="markets-up-arrow"
                  ></v-img>
                  {{ runner.batl[i][1] }}
                </span>
                <span v-else class="d-block text-center">-</span>
              </span>
            </btn-odds>
          </template>
        </v-card>
  
        <bet-popover
          v-if="
            $breakpoint.smAndDown &&
            betslipOpener($auth, $store, runner.id, markets.marketId)
          "
          :key="`p-${k}`"
          :check-id="runner.marketId"
        ></bet-popover>
      </template>
      <!-- // eslint-disable-next-line vue/no-lone-template -->
      <template v-if="$auth.loggedIn && !$breakpoint.xsOnly && minmax.length">
        <v-card class="d-flex align-center item-odds" dense flat tile height="55">
          <v-btn
            text
            tile
            color="white"
            class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
          >
            <span class="black--text manage-overflow-two"> Max Bet </span>
          </v-btn>
          <template v-for="(i, key) in xsOnlyOdds(true, 'back')">
            <div v-if="minmax && minmax[i].maxBet" :key="'back' + key">
              <v-btn
                class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center didMutate px-1"
                style="
                  font-size: 10px !important;
                  letter-spacing: 0px;
                  height: 40px;
                  margin: 1px;
                "
                small
                tile
                depressed
              >
                <span class="d-block text-center">
                  {{ minmax[i].maxBet }}
                </span>
              </v-btn>
            </div>
          </template>
  
          <template v-for="(i, key) in xsOnlyOdds(true)">
            <div v-if="minmax && minmax[i].maxBet" :key="'lay' + key">
              <v-btn
                class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center didMutate px-1"
                style="
                  font-size: 10px !important;
                  letter-spacing: 0px;
                  height: 40px;
                  margin: 1px;
                "
                small
                tile
                depressed
              >
                <span class="d-block text-center">
                  {{ minmax[i].maxBet }}
                </span>
              </v-btn>
            </div>
          </template>
        </v-card>
      </template>
    </div>
  </template>
  <script>
  import { mapState } from 'vuex'
  // import upperFirst from 'lodash/upperFirst'
  // import merge from 'lodash/merge'
  // import cloneDeep from 'lodash/cloneDeep'
  // import isString from 'lodash/isString'
  // import forEach from 'lodash/forEach'
  import isString from 'lodash/isString'
  import BtnOdds from '@/components/BtnOdds'
  import OddsDisabled from '@/components/OddsDisabled'
  import BetPopover from '@/components/BetPopover'
  // import SimpleBar from '@/components/toolbars/SimpleBar'
  import socket from '~/plugins/socket.client'
  export default {
    name: 'BookmakerItemOdds',
    components: {
      BtnOdds,
      BetPopover,
      // SimpleBar,
      OddsDisabled
    },
    props: {
      market: { type: Object, default: () => {}, required: true },
      marketId: { type: [String, Number], default: 0, required: true },
      twoOdds: { type: Boolean, default: false },
      maxCommission: { type: Number, default: 0, required: false },
      runners: { type: Array, default: () => [], required: true }
    },
    data() {
      return {
        markets: {},
        socketStatus: '',
        newPlacebet: {},
        socketData: {},
        minmax: [],
        refresh: true
      }
    },
    computed: {
      ...mapState({
        books: (state) => state.betBooks.bookmakerMarketData,
        newbookmakerMarketData: (state) => state.betBooks.newbookmakerMarketData,
        matchIds: (state) => state.placeBet.matchIds,
        minMaxMarket: (state) => state.matchInside.minMaxMarketBookmaker
      })
    },
    mounted() {
      if (
        this.market &&
        this.market.artemisMatchOddsData &&
        this.market.artemisMatchOddsData[0] &&
        this.market.artemisMatchOddsData[0].runner
      ) {
        this.newPlacebet = this.market.artemisMatchOddsData[0]
        this.markets = this.market.artemisMatchOddsData[0].runner
        this.socketStatus = this.market.artemisMatchOddsData[0].status
      }
      if (this.market && this.market.eventId) {
        socket.commonSocket.on(
          'AllSocket_Event_Bookmaker_' + this.market.eventId,
          (socketData) => {
            if (socketData && socketData.length > 0) {
              const findOut = socketData.find((obj) => obj.name === 'Match Odds')
              if (
                findOut &&
                findOut.name &&
                findOut.name === 'Match Odds' &&
                findOut.runner
              ) {
                this.newPlacebet = findOut
                this.socketStatus = findOut.status
                this.markets = findOut.runner
              }
            }
          }
        )
      }
      // socket.commonSocket.on('AllSocket_Market_' + this.marketId, (data) => {
      //   // eslint-disable-next-line vue/no-mutating-props
      //   this.markets = data
      // })
    },
    methods: {
      xsOnlyOdds(bool, type) {
        if (bool) {
          return [0]
        } else {
          if (type === 'back') {
            return [2, 1, 0]
          }
          return [0, 1, 2]
        }
      },
      getObjValue(object, i, j, output) {
        return object && object.length ? object[i][j] : output
      },
      getBooks(books, id, sequence) {
        if (sequence === '1') {
          if (
            books &&
            books[this.markets[0].marketId] &&
            books[this.markets[0].marketId]?.length > 0
          ) {
            const horses =
              books[this.markets[0].marketId][0]?.book ||
              books[this.markets[0].marketId][0]?.horses ||
              []
            const value = horses.find((e) => {
              let horseId = e?._id || e?.horse
              if (!isString(id)) {
                horseId = parseInt(horseId)
              }
              if (horseId === id) {
                return e
              } else {
                return 0
              }
            })
            if (value && value.amount) {
              return value.amount || ''
            } else {
              return 0
            }
          } else {
            return 0
          }
        }
      },
      check(runner, key, i, markets) {
        let result = false
        if (markets && markets[0]) {
          if (key !== 'batl') {
            i = 2 - i
          }
          result =
            runner &&
            runner[key] &&
            runner[key].length > 0 &&
            runner[key][0] &&
            runner[key][0].length > 0 &&
            runner[key][0][i]
        } else {
          result =
            runner &&
            runner[key] &&
            runner[key].length > 0 &&
            runner[key][i] &&
            runner[key][i].length > 0 &&
            runner[key][i][1]
        }
        return result
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .opacity-0 {
    opacity: 0;
  }
  
  .markets-down-arrow,
  .markets-up-arrow {
    position: absolute !important;
    top: 20% !important;
    left: 5px !important;
    z-index: 1 !important;
  }
  </style>